import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  inheritAttrs: false
})
class EdCheckboxForm extends Vue {

  @Prop() readonly label: string;
  @Prop() readonly disclamer: string;
  @Prop() readonly disabled: boolean;
  @Prop({ default: 18 }) readonly size: number;

  /* Out */
  public readonly change: string = 'change';

  public checked: boolean = false;

  get checkboxStyles() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
    };
  }

  mounted() {
      this.valueChanged();  
  }

  @Watch('checked')
  checkedChanged() {
    this.updateInput();
  }

  @Watch('$attrs')
  valueChanged() {
    let vModel: any = this.$attrs.value;
    if (typeof vModel == 'boolean') {
      this.checked = vModel;  
    } else {
      this.checked = vModel.value;
    }
  }

  onChanged() {
    this.updateInput();
    this.$emit(this.change, this.checked);
  }

  updateInput() {
    let vModel: any = this.$attrs.value;
    if (typeof vModel == 'boolean') {
      this.$emit('input', this.checked);
    } else {
      this.$emit('input', {
        ...vModel,
        value: this.checked,
        valid: true,
      });
    }
  }

}

export default Vue.component('ed-checkbox-form', EdCheckboxForm);
